import { Box, Checkbox, FormControlLabel, Modal } from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useFieldArray, useForm } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useEffect, useMemo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';
import Pagination from '@/components/ui/Pagination/Pagination';
import ModalStyle from '@/constants/ModalStyle';
import Loader from '@/components/ui/Loader/Loader';

import usePatch from '@/hooks/usePatch';

import file from '@/api/file';

const schema = yup.object().shape({});

const { getComponentAttachments } = file();

// const priv = [
// 	{ id: 1, name: 'developer', value: true },
// 	{ id: 99, name: 'private', value: true },
// 	{ id: 2, name: 'admin', value: true },
// 	{ id: 3, name: 'product_manager', value: true },
// 	{ id: 4, name: 'project_manager', value: true },
// 	{ id: 5, name: 'employee', value: true },
// 	{ id: 6, name: 'public', value: true },
// ];

const priv = {
	developer: 1,
	private: 99,
	admin: 2,
	product_manager: 3,
	project_manager: 4,
	employee: 5,
	public: 6,
};

export default function DataSheet(props) {
	const { open, onClose, data } = props;

	// const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });

	const isEdit = !!data;

	const { handleSubmit, control, setValue, reset } = useForm({
		resolver: yupResolver(schema),
		defaultValues: {},
	});

	useFieldArray({ control, name: 'files' });

	const { data: docs, isFetching: isFetchingD } = useQuery({
		queryKey: ['file'],
		queryFn: () => getComponentAttachments(data.productid),
		enabled: !!data.productid,
	});

	const dataList = useMemo(() => docs?.data?.attachments || [], [docs]) || [];

	useEffect(() => {
		if (docs?.data && typeof docs.data !== 'string') {
			docs.data.attachments?.forEach((d) => {
				setValue(`files.${d.datasheetid}.developer`, true);
				setValue(`files.${d.datasheetid}.private`, +d.private === 1);
				setValue(`files.${d.datasheetid}.admin`, d.privilegelevelid.includes(2));
				setValue(`files.${d.datasheetid}.product_manager`, d.privilegelevelid.includes(3));
				setValue(`files.${d.datasheetid}.project_manager`, d.privilegelevelid.includes(4));
				setValue(`files.${d.datasheetid}.employee`, d.privilegelevelid.includes(5));
				setValue(`files.${d.datasheetid}.public`, d.privilegelevelid.includes(6));
			});
		}
	}, [docs, setValue]);

	const handleClose = () => {
		reset();
		onClose();
	};

	const {
		mutate: postAttachment,
		isPending,
		isSuccess,
	} = usePatch({
		url: `component_attachment/${data.productid}`,
		method: 'post',
		type: 'form-data',
		callback: (res) => {
			if (res.status === 200 && res.data) {
				toast.success(`updated successfully`);
				handleClose();
			}
		},
		onError: () => {},
		showError: true,
	});

	const onSubmit = async (data) => {
		if (!props.data.productid) return;
		const privileges = [];
		let i = 0;
		data.files.forEach((d) => {
			const privS = Object.keys(d).map((k) => {
				return { id: priv[k], name: k, value: d[k] };
			});
			const newPriv = privS
				.filter((f) => f.id !== 99)
				.filter((p) => p.value)
				.map((p) => p.id)
				.toString()
				.trim();
			const obj = { ...dataList[i], privilegelevelid: newPriv, private: privS.find((p) => p.id === 99 && !!p.value) ? 1 : 0 };
			privileges.push(obj);
			i++;
		});

		const fData = new FormData();
		fData.append('attachments', JSON.stringify(privileges));
		await postAttachment(fData);
	};

	const columns = [
		{
			field: 'linkdatasheet',
			headerName: 'Filnavn',
			headerAlign: 'center',
			align: 'left',
			flex: 1,
		},
		{
			field: '99',
			headerName: 'QR kode',
			headerAlign: 'center',
			align: 'center',
			renderCell: (params) => {
				return (
					<Controller
						control={control}
						name={`files.${params.row.datasheetid}.private`}
						render={({ field: { onChange, value } }) => (
							<FormControlLabel className='!mr-0' control={<Checkbox checked={value} onChange={onChange} />} />
						)}
					/>
				);
			},
		},
		// {
		// 	field: '2',
		// 	headerName: 'Administrasjon',
		// 	headerAlign: 'center',
		// 	align: 'center',
		// 	renderCell: (params) => {
		// 		return (
		// 			<Controller
		// 				control={control}
		// 				name={`files.${params.row.datasheetid}.admin`}
		// 				render={({ field: { onChange, value } }) => (
		// 					<FormControlLabel className='!mr-0' control={<Checkbox checked={value} onChange={onChange} />} />
		// 				)}
		// 			/>
		// 		);
		// 	},
		// },
		// {
		// 	field: '3',
		// 	headerName: 'Produktsjef',
		// 	headerAlign: 'center',
		// 	align: 'center',
		// 	renderCell: (params) => {
		// 		return (
		// 			<Controller
		// 				control={control}
		// 				name={`files.${params.row.datasheetid}.product_manager`}
		// 				render={({ field: { onChange, value } }) => (
		// 					<FormControlLabel className='!mr-0' control={<Checkbox checked={value} onChange={onChange} />} />
		// 				)}
		// 			/>
		// 		);
		// 	},
		// },
		// {
		// 	field: '4',
		// 	headerName: 'Prosjektleder	',
		// 	headerAlign: 'center',
		// 	align: 'center',
		// 	renderCell: (params) => {
		// 		return (
		// 			<Controller
		// 				control={control}
		// 				name={`files.${params.row.datasheetid}.project_manager`}
		// 				render={({ field: { onChange, value } }) => (
		// 					<FormControlLabel className='!mr-0' control={<Checkbox checked={value} onChange={onChange} />} />
		// 				)}
		// 			/>
		// 		);
		// 	},
		// },
		// {
		// 	field: '5',
		// 	headerName: 'Ansatt	',
		// 	headerAlign: 'center',
		// 	align: 'center',
		// 	renderCell: (params) => {
		// 		return (
		// 			<Controller
		// 				control={control}
		// 				name={`files.${params.row.datasheetid}.employee`}
		// 				render={({ field: { onChange, value } }) => (
		// 					<FormControlLabel className='!mr-0' control={<Checkbox checked={value} onChange={onChange} />} />
		// 				)}
		// 			/>
		// 		);
		// 	},
		// },
		// {
		// 	field: '6',
		// 	headerName: 'Public	',
		// 	headerAlign: 'center',
		// 	align: 'center',
		// 	renderCell: (params) => {
		// 		return (
		// 			<Controller
		// 				control={control}
		// 				name={`files.${params.row.datasheetid}.public`}
		// 				render={({ field: { onChange, value } }) => (
		// 					<FormControlLabel className='!mr-0' control={<Checkbox checked={value} onChange={onChange} />} />
		// 				)}
		// 			/>
		// 		);
		// 	},
		// },
	];

	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-notes' aria-describedby='modal-notes' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '50%' }} className='flex flex-col gap-4 w-[90%] md:w-[786px] max-h-[90%]'>
				<span className='text-2xl modal-title'>{isEdit ? `Edit (${data.productcodenumber})` : 'Legg til ny under-kategori'}</span>
				<ButtonCloseModal onClose={handleClose} />

				<hr />

				<form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full gap-4 overflow-x-auto'>
					{isPending && !isSuccess && <Loader />}

					<div className='w-full h-full'>
						<DataGrid
							autoHeight
							rows={dataList}
							loading={isFetchingD}
							columns={columns}
							// rowsPerPageOptions={[10, 20, 50]}
							className='w-full h-full mx-auto mt-0'
							disableColumnFilter
							disableColumnSelector
							disableDensitySelector
							disableToolbarButton
							disableRowSelectionOnClick
							getRowId={(row) => row.datasheetid}
							slots={{
								pagination: Pagination,
							}}
							getRowClassName={(params) => {
								let cellClass = params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
								return cellClass;
							}}
							slotProps={{
								loadingOverlay: {
									variant: 'skeleton',
									noRowsVariant: 'skeleton',
								},
								// pagination: {
								// 	page: paginationModel.page,
								// },
							}}
							initialState={{
								// pagination: { paginationModel: { pageSize: 10 } },
							}}
							// paginationModel={paginationModel}
							// onPaginationModelChange={(obj) => setPaginationModel(obj)}
						/>
					</div>

					<hr />

					<div className='flex gap-4 ml-auto'>
						<button className='px-3 py-2 text-white rounded-md btn bg-primary' type='submit'>
							{isEdit ? 'Oppdater' : 'Legg til'}
						</button>
					</div>
				</form>
			</Box>
		</Modal>
	);
}
